import {styled, Box, Typography} from '@mui/material';

export const ProductSummaryListStyled = styled(Box)(({theme}) => ({
  display: 'flex',
  padding: theme.spacing(1)
}));

export const ProductCornerQuantityOverlay = styled('div')(({theme}) => {
  return {
    background: 'rgba(0, 0, 0, 0.6)',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    position: 'absolute',
    color: 'white',
    borderRadius: `${theme.spacing(0.5)} ${theme.spacing(0)}`,
    height: theme.spacing(2.5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    maxWidth: '100%',
    minWidth: theme.spacing(2.5),
    padding: theme.spacing(0.25)
  };
});

interface StyledDivProps {
  imageURl: string;
}

export const ProductQuantityOverlay = styled('div')(({theme}) => {
  return {
    position: 'absolute',
    width: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(6),
    color: 'white'
  };
});

export const ProductThumbnailImage = styled('div')<StyledDivProps>(({theme, imageURl}) => {
  return {
    cursor: 'pointer',
    position: 'relative',
    display: 'inline-block',
    height: theme.spacing(6),
    width: theme.spacing(6),
    background: `url(${imageURl})`,
    backgroundSize: `${theme.spacing(6)} ${theme.spacing(6)}`,
    borderRadius: theme.spacing(0.5),
    border: '1px solid #E8E8E8'
  };
});

export const ProductThumbnailImageOverlay = styled('div')(({theme}) => {
  return {
    background: 'rgba(0, 0, 0, 0.6)',
    top: theme.spacing(0),
    left: theme.spacing(0),
    position: 'absolute',
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: theme.spacing(0.5)
  };
});

export const QuantityText = styled(Typography)(({theme}) => {
  return {
    fontSize: theme.spacing(1.25),
    fontWeight: 600,
    color: 'white',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
});
